// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu__size[data-v-723855ba]{font-size:1.33em}", ""]);
// Exports
module.exports = exports;
